import React from 'react'

const About = () => {
  return (
    <section className="section about-section">
      <h1 className="section-title">about us</h1>
      <p>
        Lorem ipsum dolor sit amet consectetur adipisicing elit. 
        Quasi quis temporibus nisi ducimus laudantium voluptatem.
         Inventore deleniti explicabo reprehenderit blanditiis natus nam minus voluptatum aliquid vero illum, 
         autem accusantium sequi.Lorem ipsum dolor sit amet consectetur adipisicing elit. 
        Quasi quis temporibus nisi ducimus laudantium voluptatem.
         Inventore deleniti explicabo reprehenderit blanditiis natus nam minus voluptatum aliquid vero illum, 
         autem accusantium sequi.
      </p>
    </section>
  )
}

export default About
